/**
 * CreateAccountModal.jsx
 * Created by michaelbray on 2/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import axios from 'axios';
import * as Icons from '../../../sharedComponents/icons/Icons';

import CreateAccountForm from './CreateAccountForm';
import CreateAccountConfirmation from './CreateAccountConfirmation';

const propTypes = {
    disableAccountFeatures: PropTypes.bool,
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    signIn: PropTypes.func
};

const defaultProps = {
    disableAccountFeatures: false,
    isOpen: false,
    closeModal: () => {},
    signIn: () => {}
};

const alreadyExistsErr = "An account already exists for this email address";

export default class CreateAccountModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            errorMessage: '',
            completed: false
        };

        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.sendAccountConfirmationEmail = this.sendAccountConfirmationEmail.bind(this);
        this.confirmAccount = this.confirmAccount.bind(this);
    }

    afterOpenModal() {
        this.setState({
            firstName: '',
            lastName: '',
            email: '',
            completed: false,
            errorMessage: ''
        });
    }

    sendAccountConfirmationEmail() {
        // TODO: Validation
        if (this.state.firstName.length < 1 || this.state.lastName.length < 1 || this.state.email.length < 1) {
            this.setState({
                errorMessage: 'All fields are required.'
            });
        }
        else {
            const url = `${process.env.API}/accounts/registration`;

            axios.post(url, {
                email: this.state.email,
                first_name: this.state.firstName,
                last_name: this.state.lastName
            })
                .then(() => {
                    this.setState({
                        errorMessage: '',
                        completed: true
                    });
                })
                .catch((e) => {
                    let message = 'An error has occurred, please try again later.';
                    if (e.response.data.error === alreadyExistsErr ){
                        message = "You look familiar! This email already has an account associated with it. Click the link below to log in with this email."
                    }
                    this.setState({
                        errorMessage: message
                    });
                });
        }
    }

    confirmAccount(account) {
        this.setState({
            email: account.email,
            firstName: account.firstName,
            lastName: account.lastName
        }, () => {
            this.sendAccountConfirmationEmail();
        });
    }

    render() {
        let errorText = null;

        if ( this.state.errorMessage ){
            errorText = this.state.errorMessage;
        }

        let content = null;

        if (this.state.completed) {
            content = (
                <CreateAccountConfirmation
                    email={this.state.email}
                    sendAccountConfirmationEmail={this.sendAccountConfirmationEmail} />
            );
        }
        else {
            content = (
                <CreateAccountForm
                    disableAccountFeatures={this.props.disableAccountFeatures}
                    errorText={errorText}
                    signIn={this.props.signIn}
                    confirmAccount={this.confirmAccount} />
            );
        }

        return (
            <Modal
                role="complementary"
                isOpen={this.props.isOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.props.closeModal}
                className={{
                    base: 'rec-modal-dialog-base',
                    afterOpen: 'rec-modal-dialog-after-open-md rec-acct-modal rec-acct-create-modal',
                    beforeClose: 'rec-modal-dialog-before-close'
                }}
                overlayClassName={{
                    base: 'rec-overlay-base',
                    afterOpen: 'rec-overlay-after-open',
                    beforeClose: 'rec-overlay-before-close'
                }}
                contentLabel="Create an Account"
                ariaHideApp={false}>
                <div className="rec-modal-content-wrap">
                    <button className="rec-close-modal" onClick={this.props.closeModal}>
                        <Icons.IconClose />
                    </button>
                    {content}
                </div>
            </Modal>
        );
    }
}

CreateAccountModal.propTypes = propTypes;
CreateAccountModal.defaultProps = defaultProps;
